import tokens from '../../../foundation/tokens/js/tokens';
// Constantes.
// -----------------------------------------------------------------------------
export const FORM_GROUP_DEFAULT_MODE = 'light';
export const DEFAULT_LABEL_POSITION = 'stacked';
export const DEFAULT_LABEL_SIZE = 's';
export const MAPPINGS_MODE = {
    dark: {
        background: tokens.colors.black[100].value,
        color: tokens.colors.midnight[200].value,
        details: tokens.colors.midnight[500].value
    },
    light: {
        background: tokens.colors.white[100].value,
        color: tokens.colors.midnight[800].value,
        details: tokens.colors.midnight[500].value
    }
};
//# sourceMappingURL=FormGroup.constants.js.map